/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

export const PROGRAMS = [
  {
    "key": "cardio",
    "title": "کاردیو",
    "text": "برنامه کاردیو برای افزایش استقامت، چربی‌سوزی و داشتن انرژی بیشتر در طول روز. تمرین‌های متنوع و هیجان‌انگیز همراه با ویدیو آموزشی و توضیح دقیق که می‌تونی راحت در خونه یا باشگاه انجام بدی. مخصوص تمام سطوح ورزشی.",
    "href": "https://sequoia.fitness/cardio-program/",
    "blank": true,
    "cta": "اطلاعات بیشتر و دریافت برنامه",
    "icon": {
      "src": "a/endurance-icon-ae2a3e.webp",
      "srcset": "a/endurance-icon-ae2a3e.webp 589w, a/endurance-icon-300x288-f497a5.webp 300w, a/endurance-icon-78x75-f49532.webp 78w, a/endurance-icon-480x461-320b58.webp 480w, a/endurance-icon-150x144-fc3142.webp 150w",
      "sizes": "(max-width:767px) 480px, 589px",
      "width": "589",
      "height": "566"
    }
  },
  {
    "key": "corrective",
    "title": "اصلاحی",
    "text": "برنامه اصلاحی برای کاهش دردهای شایع مثل کمر، زانو یا شانه و اصلاح فرم بدن. شامل تمرین‌های تخصصی و ساده با ویدیو آموزشی و توضیحات کامل. مناسب همه سطوح و طراحی‌شده برای بازگرداندن بدن به تعادل و حرکت طبیعی.",
    "href": "https://sequoia.fitness/corrective-program/",
    "blank": false,
    "cta": "اطلاعات بیشتر و دریافت برنامه",
    "icon": {
      "src": "a/corrective-icon-110592.svg",
      "width": "39",
      "height": "46"
    }
  },
  {
    "key": "mobility",
    "title": "موبیلیتی",
    "text": "برنامه موبیلیتی ویژه برای افزایش انعطاف، دامنه حرکتی و پیشگیری از آسیب. تمرین‌های سبک اما مؤثر با ویدیو آموزشی و توضیح کامل، مناسب انجام در خانه یا باشگاه. کمک می‌کنه بدنت آزادتر حرکت کنه و احساس سبکی بیشتری داشته باشی.",
    "href": "https://sequoia.fitness/mobility-program/",
    "blank": false,
    "cta": "اطلاعات بیشتر و دریافت برنامه",
    "icon": {
      "src": "a/mobility-icon-612ee0.svg",
      "width": "26",
      "height": "19"
    }
  },
  {
    "key": "fitness",
    "title": "فیتنس",
    "text": "برنامه فیتنس اختصاصی برای ساختن اندام متناسب، افزایش قدرت و حجم عضلانی. شامل تمرین‌های علمی با ویدیو آموزشی و توضیح کامل، قابل اجرا توی خونه یا باشگاه. مناسب هر سطحی و طراحی‌شده دقیقاً متناسب با شرایط بدنی تو.",
    "href": "https://sequoia.fitness/fitness-program/",
    "blank": false,
    "cta": "اطلاعات بیشتر و دریافت برنامه",
    "icon": {
      "src": "a/lose-fat-icon-3222b8.webp",
      "srcset": "a/lose-fat-icon-3222b8.webp 100w, a/lose-fat-icon-78x75-34a236.webp 78w",
      "sizes": "(max-width:767px) 100px, 100px",
      "width": "100",
      "height": "96"
    }
  },
  {
    "key": "flexibility",
    "title": "انعطاف",
    "text": "برنامه انعطاف ویژه برای کشش عضلات، بهبود فرم بدن و کاهش خشکی یا گرفتگی. شامل تمرین‌های ساده اما مؤثر همراه با ویدیو آموزشی و توضیحات کامل. می‌تونی راحت در خونه یا باشگاه انجام بدی و دامنه حرکتی بدن‌ت رو بیشتر کنی.",
    "href": "https://sequoia.fitness/flexibility-program/",
    "blank": true,
    "cta": "اطلاعات بیشتر و دریافت برنامه",
    "icon": {
      "src": "a/flexible-icon-e37a24.svg",
      "width": "17",
      "height": "20"
    }
  },
  {
    "key": "warm-cool",
    "title": "گرم و سرد کردن",
    "text": "برنامه کامل گرم‌کردن و سردکردن برای آماده‌سازی بدن قبل از تمرین و ریکاوری بعد از اون. شامل حرکات سبک و کاربردی همراه با ویدیو آموزشی و توضیح کامل که کمک می‌کنه از آسیب‌ها جلوگیری کنی، عملکردت بهتر شه و ریکاوری سریع‌تری داشته باشی.",
    "href": "https://sequoia.fitness/warm-cool-program/",
    "blank": true,
    "cta": "اطلاعات بیشتر و دریافت برنامه",
    "icon": {
      "src": "a/warm-icon-f6c163.svg",
      "width": "34",
      "height": "50"
    }
  },
  {
    "key": "nutrition",
    "title": "تغذیه",
    "text": "یک پکیج کامل شامل برنامه تمرینی اختصاصی و رژیم غذایی شخصی‌سازی‌شده بر اساس شرایط بدن و هدفت. با این باندل همزمان روی فرم بدنی، قدرت و چربی‌سوزی کار می‌کنی و بهترین نتیجه رو می‌گیری. همراه با توضیح کامل و ویدیو آموزشی.",
    "href": "https://sequoia.fitness/nutritional-diet-program/",
    "blank": true,
    "cta": "اطلاعات بیشتر و دریافت برنامه",
    "icon": {
      "src": "a/adjustable-diet-icon-cc56f2.webp",
      "width": "100",
      "height": "67"
    }
  }
]

export const MEGA_PROGRAMS = [
  {
    "key": "fitness",
    "href": "/fitness-program/",
    "title": "فیتنس",
    "text": "برنامه فیتنس اختصاصی برای ساختن اندام متناسب، افزایش قدرت و حجم عضلانی. شامل تمرین‌های علمی با ویدیو آموزشی و توضیح کامل، قابل اجرا توی خونه یا باشگاه. مناسب هر سطحی و طراحی‌شده دقیقاً متناسب با شرایط بدنی تو.",
    "cta": "اطلاعات بیشتر و دریافت برنامه"
  },
  {
    "key": "cardio",
    "href": "/cardio-program/",
    "title": "کاردیو",
    "text": "برنامه کاردیو برای افزایش استقامت، چربی‌سوزی و داشتن انرژی بیشتر در طول روز. تمرین‌های متنوع و هیجان‌انگیز همراه با ویدیو آموزشی و توضیح دقیق که می‌تونی راحت در خونه یا باشگاه انجام بدی. مخصوص تمام سطوح ورزشی.",
    "cta": "اطلاعات بیشتر و دریافت برنامه"
  },
  {
    "key": "corrective",
    "href": "/corrective-program/",
    "title": "اصلاحی",
    "text": "برنامه اصلاحی برای کاهش دردهای شایع مثل کمر، زانو یا شانه و اصلاح فرم بدن. شامل تمرین‌های تخصصی و ساده با ویدیو آموزشی و توضیحات کامل. مناسب همه سطوح و طراحی‌شده برای بازگرداندن بدن به تعادل و حرکت طبیعی.",
    "cta": "اطلاعات بیشتر و دریافت برنامه"
  },
  {
    "key": "flexibility",
    "href": "/flexibility-program/",
    "title": "انعطاف",
    "text": "برنامه انعطاف ویژه برای کشش عضلات، بهبود فرم بدن و کاهش خشکی یا گرفتگی. شامل تمرین‌های ساده اما مؤثر همراه با ویدیو آموزشی و توضیحات کامل. می‌تونی راحت در خونه یا باشگاه انجام بدی و دامنه حرکتی بدن‌ت رو بیشتر کنی.",
    "cta": "اطلاعات بیشتر و دریافت برنامه"
  },
  {
    "key": "mobility",
    "href": "/mobility-program/",
    "title": "موبیلیتی",
    "text": "برنامه موبیلیتی ویژه برای افزایش انعطاف، دامنه حرکتی و پیشگیری از آسیب. تمرین‌های سبک اما مؤثر با ویدیو آموزشی و توضیح کامل، مناسب انجام در خانه یا باشگاه. کمک می‌کنه بدنت آزادتر حرکت کنه و احساس سبکی بیشتری داشته باشی.",
    "cta": "اطلاعات بیشتر و دریافت برنامه"
  },
  {
    "key": "warm-cool",
    "href": "/warm-cool-program/",
    "title": "گرم و سرد کردن",
    "text": "برنامه کامل گرم‌کردن و سردکردن برای آماده‌سازی بدن قبل از تمرین و ریکاوری بعد از اون. شامل حرکات سبک و کاربردی همراه با ویدیو آموزشی و توضیح کامل که کمک می‌کنه از آسیب‌ها جلوگیری کنی، عملکردت بهتر شه و ریکاوری سریع‌تری داشته باشی.",
    "cta": "اطلاعات بیشتر و دریافت برنامه"
  }
]
